import freeDomains from './freeDomains';

interface FilterFreeDomains {
  /** Checks if we should restrict the email domains. */
  shouldRestrictDomain: boolean;
  /** The current domain of the input. */
  currentDomain: string;
}

const filterFreeDomains = (input: string): FilterFreeDomains => {
  const currentDomain = input.substring(input.indexOf('@'));
  return {
    shouldRestrictDomain: freeDomains.includes(currentDomain),
    currentDomain,
  };
};

export default filterFreeDomains;
